import React from 'react';
import { Stack } from '../../components';
import { useTranslation } from '../../language';
import { useHubConnection } from './hub';
import dingelingsound from '../../gfx/ding2.mp3';

type QueueEntry = {
	id: string;
	roomName: string;
	queueNumber: string;
	added?: Date
}

const storeQueueInLocalStorage = (entries: Array<QueueEntry>) => {
	window.localStorage.setItem("queue", JSON.stringify(entries));
}

const getQueueFromLocalStorage = (): Array<QueueEntry> => {
	try {
		const stored = window.localStorage.getItem("queue");
		if (!stored) {
			return [];
		}
		return JSON.parse(stored);
	} catch (e) {
		return [];
	}
}

export const QueueScreen = () => {
	const [entries, setEntries] = React.useState<Array<QueueEntry>>(getQueueFromLocalStorage());

	const hub = useHubConnection();
	const translate = useTranslation();

	const addEntry = (entry: QueueEntry) => {
		entry.id = entry.id + new Date().getTime();
		entry.added = new Date();

		setEntries(data => {
			while (data.length > 7) {
				data.pop();
			}

			const newData = [entry, ...data];
			storeQueueInLocalStorage(newData);
			return newData;
		});
	};

	const clearScreenInterval = React.useCallback(() => {
		return setInterval(() => {
			// Remove any item in the list that is
			// older than 10 minutes
			setEntries(data => {
				const limit = new Date();
				limit.setMinutes(limit.getMinutes() - 2);
				// limit.setSeconds(limit.getSeconds() - 30);

				const newData = data.filter(i => {
					if (!i.added) {
						return false;
					}

					const added = new Date(i.added)
					return added > limit;
				});
				storeQueueInLocalStorage(newData);
				return newData;
			})
		}, 1 /*seconds*/ * 1000);
	}, []);

	React.useEffect(() => {
		const interval = clearScreenInterval();

		return () => {
			clearInterval(interval);
		}
	}, [clearScreenInterval]);

	React.useEffect(() => {
		hub.subscribe("CallToOffice", (data: QueueEntry) => {
			addEntry(data);
			new Audio(dingelingsound).play();
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCallinText = (entry: QueueEntry) => {
		if (entry.roomName.toLowerCase().indexOf("lab") > -1) {
			return "Nummer " + entry.queueNumber + " blir hentet";
		}
		return translate("QueueDisplay.PatientNumber") + " " + entry.queueNumber + " " + translate("QueueDisplay.ToRoom") + " " + entry.roomName
	}

	const renderItem = (entry: QueueEntry) => {
		return (
			<Stack horizontalAlign='center' key={entry.id}>
				<h1 style={{ textAlign: 'center', fontSize: '5.5rem', marginTop: 12 }}>
					{getCallinText(entry)}
				</h1>
			</Stack>
		)
	}

	return (
		<Stack>
			{entries.map(renderItem)}
		</Stack>
	)
}